'use strict';

const urlJoin = require('url-join');
const config = require('../config');
const { default: stipulate } = require('stipulate');
const { baseOptions } = require('./configuration');

const getZendeskToken = () => {
  const { baseUrl } = config.get();
  const url = urlJoin(baseUrl, '/pb/users/me/zendesk-widget-token/');
  return stipulate(url, baseOptions, 'text');
};

module.exports = getZendeskToken;
